import { render, staticRenderFns } from "./ImgUrl.vue?vue&type=template&id=4e8a324d&scoped=true"
import script from "./ImgUrl.vue?vue&type=script&lang=js"
export * from "./ImgUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a324d",
  null
  
)

export default component.exports